import { IInputConfig, ICursorConfig, IVector2,IAssetsConfig } from "../types/game-config-type";
import { IMenuCommand } from "./commands/menu-command";
import { GameConfig } from "../config/game-config";
import { Mouse } from "../input/mouse";
import { table } from "../game/table";
import { Assets } from "../game/resources";

const inputConfig: IInputConfig = GameConfig.input;
const cursorConfig: ICursorConfig = GameConfig.cursor;
const sprites: IAssetsConfig = GameConfig.sprites;

export class MenuButton {
  private activeSprite: HTMLImageElement;
  private isHovered: boolean;

  private set hovered(value: boolean) {
    this.isHovered = value;
  }

  constructor(
    private command: IMenuCommand,
    private value: any,
    private position: IVector2,
    private spriteKey: string,
    private spriteOnHoverKey: string
  ) {
    this.activeSprite = Assets.getSprite(sprites.paths[this.spriteKey]);
  }

  public handleInput(): void {
    this.hovered = this.isInsideButton(Mouse.position);
    this.activeSprite = this.isHovered
      ? Assets.getSprite(sprites.paths[this.spriteOnHoverKey])
      : Assets.getSprite(sprites.paths[this.spriteKey]);

    if (this.isHovered && Mouse.isPressed(inputConfig.mouseSelectButton)) {
      table.changeCursor(cursorConfig.default);
      this.command.execute(this.value);
    }
  }

  public update(): void {
    this.handleInput();
  }

  public draw(): void {
    if (this.isHovered) {
      table.changeCursor(cursorConfig.button);
    }
    table.drawImage(this.activeSprite, this.position);
  }

  private isInsideButton(position: IVector2) {
    return (
      position.x > this.position.x &&
      position.x < this.position.x + this.activeSprite.width &&
      position.y > this.position.y &&
      position.y < this.position.y + this.activeSprite.height
    );
  }
}
